import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useRef, useState } from 'react';
import ButtonIcon from 'react-rainbow-components/components/ButtonIcon';
import InternalOverlay from 'react-rainbow-components/components/InternalOverlay';
import { useOutsideClick } from '@rainbow-modules/hooks';
import ImportExportLogo from './icons/ImportExportLogo';
import Messages from './icons/Messages';
import { AppIcon, Item, SelectAppIcon, ItemLabel, Dropdown } from './styled';
var dispatchUrl = process.env.REACT_APP_DISPATCH_URL;
var messagesUrl = process.env.REACT_APP_MESSAGES_URL;
var dataUrl = process.env.REACT_APP_DATA_URL;
var dispatchNextUrl = process.env.REACT_APP_DISPATCH_NEXT_URL;
export default function AppsMenu(props) {
  var className = props.className,
      style = props.style,
      id = props.id;
  var triggerRef = useRef();
  var dropdownRef = useRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  useOutsideClick(dropdownRef, function (event) {
    if (!triggerRef.current.htmlElementRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  }, isOpen);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ButtonIcon, {
    icon: /*#__PURE__*/React.createElement(AppIcon, null),
    size: "large",
    variant: "base",
    className: className,
    style: style,
    id: id,
    ref: triggerRef,
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    }
  }), /*#__PURE__*/React.createElement(InternalOverlay, {
    isVisible: isOpen,
    triggerElementRef: function triggerElementRef() {
      return triggerRef.current.htmlElementRef;
    }
  }, /*#__PURE__*/React.createElement(Dropdown, {
    ref: dropdownRef
  }, /*#__PURE__*/React.createElement(Item, {
    href: dataUrl,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(SelectAppIcon, {
    as: ImportExportLogo
  }), /*#__PURE__*/React.createElement(ItemLabel, null, "Import/Export")), /*#__PURE__*/React.createElement(Item, {
    href: dispatchUrl,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(SelectAppIcon, null), /*#__PURE__*/React.createElement(ItemLabel, null, "ET Dispatch")), /*#__PURE__*/React.createElement(Item, {
    href: messagesUrl,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(SelectAppIcon, {
    as: Messages
  }), /*#__PURE__*/React.createElement(ItemLabel, null, "Message")), /*#__PURE__*/React.createElement(Item, {
    href: dispatchNextUrl,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(SelectAppIcon, null), /*#__PURE__*/React.createElement(ItemLabel, null, "Dispatch Next")))));
}
AppsMenu.defaultProps = {
  id: undefined,
  className: undefined,
  style: undefined
};